import { useQuery } from '@apollo/client';
import { GET_STAGE_TEMPLATES } from '@frontend/app/queries/stageTemplates';
import { GetStageTemplates, GetStageTemplatesVariables } from '@frontend/app/queries/types/GetStageTemplates';
import { GetStageTemplatesFilters } from '@frontend/app/types/globalTypes';

export type { GetStageTemplates_getStageTemplates as IStageTemplate } from '@frontend/app/queries/types/GetStageTemplates';
export type { GetStageTemplates_getStageTemplates_statuses as ITemplateStatus } from '@frontend/app/queries/types/GetStageTemplates';

export function useStageTemplates(filters?: GetStageTemplatesFilters) {
  const { data, loading, error, refetch } = useQuery<GetStageTemplates, GetStageTemplatesVariables>(
    GET_STAGE_TEMPLATES,
    {
      variables: { filters: filters || {} },
      fetchPolicy: 'cache-and-network'
    }
  );

  return {
    templates: data?.getStageTemplates || [],
    loading,
    error,
    refetch
  };
}
